import axios from './api' // 倒入 api

const doLogin = (params) => {
  return axios({
    url: '/api/login',
    method: 'GET',
    params,
  })
}
const doLoginReconfirm2 = (params) => {
  return axios({
    url: '/api/login/reconfirm2',
    method: 'GET',
    params,
  })
}
const getImgCode = () => {
  return axios({
    url: '/api/login/getImgCode',
  })
}
const personalSetting = (tenantId) => {
  return axios({
    url: `/api/tenant/${tenantId}`,
    method: 'GET',
  })
}
const renewRemind = (params) => {
  return axios({
    url: '/api/tenant/renew/remind',
    method: 'GET',
    params,
  })
}

export const getUserAuth = () => {
  return axios({
    url: '/api/auth/menu/currentuser',
    method: 'GET',
  })
}
//退出登录
const loginOut = () => {
  return axios({
    url: '/api/logout',
    method: 'GET',
  })
}

//获取用户列表
const getAllUser = () => {
  return axios({
    url: '/api/user/simple',
    method: 'GET',
  })
}
//账号和司机绑定后，新增司机不能显示已绑定的账号
const getCanUseUser = () => {
  return axios({
    url: '/api/driver/user/list',
    method: 'GET',
  })
}

//获取数据字典
const getDictlist = (params) => {
  return axios({
    url: '/api/common/dictlist',
    method: 'GET',
    params,
  })
}

//获取司机简易列表
const getSimpleDriver = () => {
  return axios({
    url: '/api/driver/simple',
    method: 'GET',
  })
}

//获取车辆简易列表
const getSimpleCar = (params) => {
  return axios({
    url: '/api/car/simple',
    method: 'GET',
    params,
  })
}

export const getDictAreaTree = () => {
  return axios({
    url: '/api/workOrder/dict/area-tree'
  })
}
export const getProvince = () => {
  return axios({
    url: '/api/location/province',
    method: 'GET',
  })
}

// 修改区域
export const getArea = (code) => {
  return axios({
    url: `/api/location/area/${code}`,
    method: 'GET',
  })
}
// 获取城市
export const getCity = (code) => {
  return axios({
    url: `/api/location/city/${code}`,
    method: 'GET',
  })
}

//获取消息未读条数
// const getUnreadnum = () => {
//   return axios({
//     url: '/api/message/pc/unreadnum',
//     method: 'GET',
//   })
// }
//获取消息未读条数
const getUnreadnum = () => {
  return axios({
    url: '/api/remind/unread/count',
    method: 'GET',
  })
}

//获取未处理报警
const getUnreadAlarm = () => {
  return axios({
    url: '/api/alarm/unread/count',
    method: 'GET',
  })
}

//获取消息列表
const getMsgList = (params) => {
  return axios({
    url: '/api/approval/remind',
    method: 'get',
    params,
  })
}
// //获取消息列表
// const getMsgList = (params) => {
//   return axios({
//     url: '/api/message/pc/list',
//     method: 'POST',
//     params
//   })
// }
//获取消息未读数
const getunReadNum = () => {
  return axios({
    url: `/api/remind/unread/count`,
    method: 'GET',
  })
}
//获取保险提醒
const getInsuranceList = (params) => {
  return axios({
    url: `/api/insure/remind`,
    method: 'GET',
    params,
  })
}
//保险已读
const illeageRead = (data) => {
  return axios({
    url: `/api/remind/read`,
    method: 'PUT',
    data,
  })
}
//年检列表
const yearDataList = (params) => {
  return axios({
    url: `/api/mot/remind`,
    method: 'GET',
    params,
  })
}
const illegalNotice = (params) => {
  return axios({
    url: '/api/violation/remind',
    method: 'GET',
    params,
  })
}
// 车务
const serviceRemind = (params) => {
  return axios({
    url: '/api/service/remind',
    method: 'GET',
    params,
  })
}
//用车通知
const userCarRemind = (params) => {
  return axios({
    url: '/api/notice/remind',
    method: 'GET',
    params,
  })
}
//用车通知已读
const userCarRemindEnRead = (data) => {
  return axios({
    url: '/api/notice/read',
    method: 'PUT',
    data,
  })
}
//批量已读
const readflag = (params) => {
  return axios({
    url: '/api/message/pc/read',
    method: 'PUT',
    params,
  })
}

//全部已读
const readall = (params) => {
  return axios({
    url: '/api/message/pc/readall',
    method: 'PUT',
    params,
  })
}

const modifyPsw = (params) => {
  return axios({
    url: '/api/user/psw',
    method: 'PUT',
    params,
  })
}

//获取流程列表
const getFlowList = () => {
  return axios({
    url: '/api/flowroute/list',
    method: 'GET',
  })
}
// 默认全部倒出
// 根绝需要进行
export default {
  doLogin,
  doLoginReconfirm2,
  getImgCode,
  personalSetting,
  renewRemind,
  loginOut,
  getAllUser,
  getCanUseUser,
  getDictlist,
  getSimpleDriver,
  getSimpleCar,
  getUserAuth,
  getDictAreaTree,
  getProvince,
  getArea,
  getCity,
  getUnreadnum,
  getMsgList,
  readflag,
  readall,
  modifyPsw,
  getUnreadAlarm,
  getFlowList,
  getInsuranceList,
  illeageRead,
  yearDataList,
  illegalNotice,
  serviceRemind,
  getunReadNum,
  userCarRemind,
  userCarRemindEnRead,
}
